import { mimes } from 'vee-validate/dist/rules';

const handler = {
  validate: (field, options) => mimes.validate(field, options.values),
  params: ['values']
};

export { handler as mimes };
